import greenCheckmarkVolume from 'assets/icon/green-checkmark-volume.svg'

const TestCard = ({ title, description, icon, id, isSelected, onSelect, slug, name }) => {
  const handleSelect = () => {
    onSelect({
      id,
      slug,
      title,
      name,
    })
  }

  return (
    <button
      onClick={handleSelect}
      className={`text-left bg-primary-500 p-[24px] rounded-[10px] flex flex-col items-start justify-start relative border-[1px] transition-colors duration-200 ease ${isSelected ? 'shadow-category-selected border-warning-500' : 'border-transparent'}`}
    >
      {isSelected && (
        <div className="absolute top-[10px] right-[10px]">
          <img src={greenCheckmarkVolume} alt="Checkmark" />
        </div>
      )}

      <div className="mb-3">
        <img className="block" src={icon} alt={name} />
      </div>

      <h3 className="text-primary-100 font-semibold text-[18px] leading-[30px]">{name}</h3>

      <p className="max-w-[236px] w-full leading-5 text-warning-500">{description}</p>
    </button>
  )
}

export default TestCard
